import { useActionPanelStyles } from '@modules/encoding/shared/components/ActionPanel/ActionPanel.style';
import { FC, PropsWithChildren } from 'react';

export const ActionPanel: FC<PropsWithChildren> = ({ children }) => {
    const { classes } = useActionPanelStyles();

    return <div className={classes.actionPanel}>{children}</div>;
};
